module.exports = __webpack_public_path__ + "img/sd.7958234b.png";